{
  "longPressMessage": "長按以開啟預覽"
}
